import * as Types from '../../../../types/schema.generated';

import gql from 'graphql-tag';
export type EnqueteFormQuestionUserVariableDefinitionFragment = { __typename?: 'UserVariableDefinition', guid: string, name: string, value: { __typename: 'UserVariableDefinitionValueMultipleSelect', options: Array<{ __typename?: 'UserVariableDefinitionValueSelectOption', guid: string, name: string }> } | { __typename: 'UserVariableDefinitionValueSelect', options: Array<{ __typename?: 'UserVariableDefinitionValueSelectOption', guid: string, name: string }> } | { __typename: 'UserVariableDefinitionValueString', void: any } | { __typename: 'UserVariableDefinitionValueText', void: any } };

export const EnqueteFormQuestionUserVariableDefinitionFragmentDoc = gql`
    fragment EnqueteFormQuestionUserVariableDefinition on UserVariableDefinition {
  guid
  name
  value {
    __typename
    ... on UserVariableDefinitionValueString {
      void
    }
    ... on UserVariableDefinitionValueText {
      void
    }
    ... on UserVariableDefinitionValueSelect {
      options {
        guid
        name
      }
    }
    ... on UserVariableDefinitionValueMultipleSelect {
      options {
        guid
        name
      }
    }
  }
}
    `;